import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';

import {
  GET_TOKEN,
  GET_RESET_PASSWORD_TOKEN,
  SET_TWO_FACTOR_AUTH_REQUIRED,
  REMOVE_TWO_FACTOR_AUTH_REQUIRED,
  RESET_STATE,
  SET_MFA_STATUS
} from './mutationTypes';
import createState from './state';

export default {
  [GET_TOKEN](state, loginRequest) {
    state.loginRequest = loginRequest;
  },

  [GET_RESET_PASSWORD_TOKEN](state, resetPasswordRequest) {
    state.resetPasswordRequest = resetPasswordRequest;
  },

  [SET_TWO_FACTOR_AUTH_REQUIRED](state) {
    state.twoFactorAuthRequired = true;
  },

  [REMOVE_TWO_FACTOR_AUTH_REQUIRED](state) {
    state.loginRequest = {};
    state.resetPasswordRequest = {};
    state.twoFactorAuthRequired = false;
  },

  [SET_MFA_STATUS](state, { hasMfa, enforceMfa }) {
    state.hasMfa = hasMfa;
    state.enforceMfa = enforceMfa;
  },

  [RESET_STATE](state) {
    Object.assign(state, createState());
  },

  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
};